import React, { useState } from 'react'
import Title from 'app-components/general/Title'
//  const title = 'RUNNING EXPERT'
const initialState = {
  name: <Title />,
  version: process.env.REACT_APP_VERSION
}

export const AppContext = React.createContext(initialState)

export const AppProvider = ({ children }) => {
  const [redirectUrl, setRedirectUrl] = useState('')
  const [pageTitle, setPageTitle] = useState(initialState.name)
  const [isHeaderVisible, setHeaderVisibility] = useState(true)

  return <AppContext.Provider value={{
    ...initialState,
    redirectUrl,
    pageTitle,
    isHeaderVisible,
    setRedirectUrl,
    setPageTitle,
    setHeaderVisibility,
  }}>
    {children}
  </AppContext.Provider>
}